import { PageHeader, Stack } from '@cast/design-system';
import { ClustersPageFilters } from '@cast/features-cluster-filters';
import { TrialClusterLimitTracker } from '@cast/shared-trial-ui';

import { ConnectClusterButton } from './ConnectClusterButton';

type ClustersPageHeaderProps = {
  showFilters?: boolean;
  onConnectCluster?: () => void;
  isConnectClusterDisabled?: boolean;
};

export const ClustersPageHeader = ({
  showFilters = false,
  onConnectCluster,
  isConnectClusterDisabled,
}: ClustersPageHeaderProps) => (
  <PageHeader
    heading="Clusters"
    endContent={
      onConnectCluster ? (
        <Stack direction="row" alignItems="center" gap={24}>
          <TrialClusterLimitTracker />
          <ConnectClusterButton
            onConnectCluster={onConnectCluster}
            disabled={isConnectClusterDisabled}
          />
        </Stack>
      ) : undefined
    }
    metadata={showFilters ? <ClustersPageFilters /> : undefined}
    testId="clusters-page-header"
    sx={{ gap: 24 }}
  />
);
